module.exports = __webpack_public_path__ + "static/media/logo.b9a5829f.png";